import { render, staticRenderFns } from "./StartDeletionAction.vue?vue&type=template&id=176492f9&"
import script from "./StartDeletionAction.vue?vue&type=script&lang=ts&"
export * from "./StartDeletionAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports